export const PO_STATUS = [
  { label: 'Approved', value: 'approved' },
  { label: 'Discarded', value: 'discarded' },
  { label: 'Done', value: 'done' },
  { label: 'Draft', value: 'draft' },
  { label: 'Pending', value: 'pending' },
  { label: 'Issued', value: 'issued' },
  { label: 'Sent', value: 'sent' },
  { label: 'In transit', value: 'in transit' },
];

export const getPurchaseOrderBadgeColor = status => {
  switch (status) {
    case 'draft':
      return 'light';

    case 'approved':
      return 'primary';

    case 'done':
      return 'success';

    case 'discarded':
      return 'secondary';

    case 'pending':
    case 'issued':
    case 'sent':
    case 'in transit':
      return 'warning';

    default:
      return 'light';
  }
};

export const getPurchaseOrderLineBadgeColor = status => {
  switch (status) {
    case 'processing':
      return 'primary';

    case 'created':
      return 'secondary';

    case 'completed':
      return 'success';

    default:
      return 'light';
  }
};
